export class BulletinService {
  constructor(fetchData) {
    this.fetchData = fetchData;
  }

  // Get all bulletins
  async getAllBulletins(params = {}) {
    return await this.fetchData({
      url: "ebulletin/bulletins",
      method: "GET",
      params,
    });
  }

  // Create new bulletin
  async createBulletin(data) {
    return await this.fetchData({
      url: "ebulletin/bulletins",
      method: "POST",
      data,
    });
  }

  // Get specific bulletin
  async getBulletin(id) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${id}`,
      method: "GET",
    });
  }

  // Update bulletin
  async updateBulletin(id, data) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${id}`,
      method: "PUT",
      data,
    });
  }

  // Delete bulletin
  async deleteBulletin(id) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${id}`,
      method: "DELETE",
    });
  }

  // Add to your BulletinService class
  async reorderBulletins(bulletinIds) {
    return await this.fetchData({
      url: "ebulletin/bulletins/reorder",
      method: "PUT",
      data: { bulletinIds },
    });
  }
}
